const STORAGE_KEY = 'safeguardpro_db_settings';

const DEFAULT_SETTINGS = {
  enabled: false,
  host: 'localhost',
  port: 3306,
  database: '',
  username: '',
  password_encrypted: '',
  ssl: false,
  updated_by: '',
  updated_at: ''
};

const readSettings = () => {
  if (typeof window === 'undefined') return { ...DEFAULT_SETTINGS };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_SETTINGS, ...parsed };
  } catch (error) {
    return { ...DEFAULT_SETTINGS };
  }
};

const writeSettings = (settings) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
};

export default class DatabaseSettingsService {
  get() {
    return readSettings();
  }

  save(settings, user) {
    const next = {
      ...readSettings(),
      ...settings,
      updated_by: user?.name || user?.id || 'system',
      updated_at: new Date().toISOString()
    };
    writeSettings(next);
    return next;
  }
}
